import { useState } from 'react'
import { useAsync } from 'react-use'

import { fetchGtcBillingAccess } from 'utils'
import { useAccountContext } from '../components/contexts/AccountContext'

export interface UseGtcBillingAccess {
  canViewGtcBilling: boolean
  canPayInGtcBilling: boolean
  canViewBillingDetailsInGtcBilling: boolean
  isGtcBillingAccount: boolean
}

const INITIAL_STATE = {
  canViewGtcBilling: false,
  canPayInGtcBilling: false,
  canViewBillingDetailsInGtcBilling: false,
  isGtcBillingAccount: false,
}

const useGtcBillingAccess = (): UseGtcBillingAccess => {
  const { orgId: organizationId } = useAccountContext()
  const [hasGtcBillingAccess, setHasGtcBillingAccess] = useState(INITIAL_STATE)

  useAsync(async () => {
    if (!organizationId) return

    const access = await fetchGtcBillingAccess({ organizationId })
    setHasGtcBillingAccess({
      canViewGtcBilling: access?.canView || false,
      canPayInGtcBilling: access?.canPay || false,
      canViewBillingDetailsInGtcBilling: access?.canViewBillingDetails || false,
      isGtcBillingAccount: access?.isGtcBillingAccount || false,
    })
  }, [organizationId])

  return hasGtcBillingAccess
}

export default useGtcBillingAccess
